import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
import * as CookieService from '../CookieService';
import swal from 'sweetalert';
const pageLoad = () => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManageForm,
            SDIConstants.methodNames.ManageForms_PageLoad,
            "",
            (data) => {
                if (data.success) {
                    ;
                    if (data.response != "" && data.response) {
                        let contentData = { type: "formPageLoadResponse", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const saveAttachment = async (attachmentBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManageForm,
            SDIConstants.methodNames.ManageForms_SaveImg,
            JSON.stringify(attachmentBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "saveattachment_Response", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        } else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Error in saving the Image"
                            });
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const addAttachment = async (files) => {
    try {
        SDISVC.uploadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_AttachFiles,
            "",
            files,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "AddForm_UploadAttachments", response: data.response };
                        Dispatcher.dispatch(contentData);
                    } else {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Error in uploading Image"
                        });
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const downloadAttachment = async (downloadBO) => {
    try {
        SDISVC.downloadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_DownloadFile,
            JSON.stringify(downloadBO),
            downloadBO.fileName,
            (data) => {
                if (data.success) {
                }
                //5770 - Removed a Swal message error in downloading image [4/23/2025]Nachiappan
            });
    } catch (ex) {
        console.log(ex)
    }
};
const removeAttachment = async (removeBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_RemoveFile,
            JSON.stringify(removeBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "AddForm_RemoveAttachment", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        } else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Error in removing Image"
                            });
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const saveForm = (saveFormBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManageForm,
            SDIConstants.methodNames.ManageForms_SaveForm,
            JSON.stringify(saveFormBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "saveFormResponse", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const cloneForm = (cloneFormBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManageForm,
            SDIConstants.methodNames.ManageForms_SaveForm,
            JSON.stringify(cloneFormBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "cloneFormResponse", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const saveClick = (saveFormBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManageForm,
            SDIConstants.methodNames.ManageForms_SaveFormName,
            JSON.stringify(saveFormBO),
            (data) => {
                if (data.success) {
                    ;
                    if (data.response != "" && data.response) {
                        let contentData = { type: "saveFormNameResponse", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const deleteForm = (deleteFormBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManageForm,
            SDIConstants.methodNames.ManageForms_DeleteForm,
            JSON.stringify(deleteFormBO),
            (data) => {
                if (data.success) {
                    ;
                    if (data.response != "" && data.response) {
                        let contentData = { type: "deleteFormResponse", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
export { pageLoad, deleteForm, saveForm, saveClick, getCurrentFavPage, deleteFavPage, insertFavPage, addAttachment, downloadAttachment, removeAttachment, saveAttachment, cloneForm }